var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-vieWide",attrs:{"id":"app"}},[_c('no-ssr',[_c('vue-progress-bar')],1),_c('app-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }